import { createUseStyles } from '@glu/theming';

const styles = {
  amountField: {
    '&::-ms-clear': {
      display: 'none'
    }
  },
  textRightAlign: {
    textAlign: 'right'
  }
};

export default createUseStyles(styles);
